import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';

export default function ServiceCTA() {
  return (
    <div className="my-8 rounded-2xl bg-primary text-primary-foreground p-6">
      <h2 className="text-xl font-bold">Talk with M Garage Door Repair</h2>
      <p className="mt-2 text-sm">Tell us your location and what the door is doing. Call for urgent assistance or send an estimate request.</p>
      <div className="mt-5 flex flex-col sm:flex-row gap-3">
        <a href="tel:+19708290330" className="inline-flex min-h-12 items-center justify-center gap-2 rounded-full bg-background text-foreground px-5 py-3 font-semibold"><Phone className="h-4 w-4" /> (970) 829-0330</a>
        <Link to="/contact#contact" className="inline-flex min-h-12 items-center justify-center rounded-full border border-current px-5 py-3 font-semibold">Request an estimate</Link>
      </div>
    </div>
  );
}